import {useCallback, useEffect, useState} from "react";
import {useSnackbarContext} from "../../common/Snackbar";
import {findDeviceById, updateDeviceById} from "../../../api/DeviceApi";

export default function UseDeviceSettings({deviceId}) {
    const [device, setDevice] = useState(undefined);
    const [deviceLoading, setDeviceLoading] = useState(true);

    const {handleMessageUpdate} = useSnackbarContext();

    function handleApiError(error) {
        handleMessageUpdate(`${error.message} [${error.code}]`);
    }

    const handleErrorCallback = useCallback(handleApiError, []);

    useEffect(() => {
        function handleDeviceChanged(device) {
            setDevice(device);
        }

        function handleDeviceLoadingChanged(value) {
            setDeviceLoading(value);
        }

        findDeviceById(deviceId)
            .then(device => {
                handleDeviceChanged(device);
                handleDeviceLoadingChanged(false);
                return Promise.resolve();
            })
            .catch(error => {
                handleDeviceLoadingChanged(false);
                handleErrorCallback(error);
            });
    }, [deviceId, handleErrorCallback]);

    function handleProtocolChanged(protocol, settings) {
        setDevice(Object.assign({}, device, {
                protocol: protocol,
                settings: Object.assign({}, device.settings, settings)
            })
        );
    }

    function handleSettingsChanged(settings) {
        setDevice(Object.assign({}, device, {
            settings: Object.assign({}, device.settings, settings)
        }));
    }

    function handleMetadataChanged(metadata) {
        setDevice(Object.assign({}, device, {
            metadata: Object.assign({}, device.metadata, metadata)
        }));
    }

    function handleSettingsApply() {
        return updateDeviceById(deviceId, {
            title: device.title,
            protocol: device.protocol,
            settings: device.settings,
            metadata: device.metadata
        }).catch(error => {
            handleApiError(error);
        });
    }

    return {
        device,
        deviceLoading,
        handleProtocolChanged,
        handleSettingsChanged,
        handleMetadataChanged,
        handleSettingsApply
    };
}